import { render, staticRenderFns } from "./per-number.vue?vue&type=template&id=23c5dc16&"
import script from "./per-number.vue?vue&type=script&lang=js&"
export * from "./per-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports